// @noflow
import { MainContainer, Mask, PageContainer } from './style';
import { RecipeDetail, RecipeSchedule, TemplatesList } from '../';

import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

RecipeModal.propTypes = {
    consumerId: PropTypes.string,
    currentPage: PropTypes.number.isRequired,
    currentRecipe: PropTypes.object,
    producerId: PropTypes.string,
    templates: ImmutablePropTypes.list.isRequired
};

export default function RecipeModal({ consumerId, currentPage, currentRecipe, producerId, templates }) {
    return (
        <Mask>
            <MainContainer currentPage={currentPage}>
                <PageContainer>
                    <TemplatesList producerId={producerId} specificConsumerId={consumerId} templatesList={templates} />
                </PageContainer>
                <PageContainer>
                    {currentRecipe && (
                        <RecipeDetail
                            currentRecipe={currentRecipe}
                            specificConsumerId={consumerId}
                            specificProducerId={producerId}
                        />
                    )}
                </PageContainer>
                <PageContainer>{currentRecipe && <RecipeSchedule />}</PageContainer>
            </MainContainer>
        </Mask>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-modal/component.js